<div fxLayout="row">
    @if (hasEditFunction) {
    <forge-icon-button [disabled]="!canEdit()" (click)="fireCustomFunction()" telemetry="Submission-Edit" aria-label="Edit">
        <forge-tooltip placement="bottom">Edit</forge-tooltip>
        <forge-icon name="edit"></forge-icon>
    </forge-icon-button>
    }

    @if (showDelete()) {
    <forge-icon-button [disabled]="!canDelete()" (click)="delete()" telemetry="Submission-Delete" aria-label="Delete">
        <forge-tooltip placement="bottom">Delete</forge-tooltip>
        <forge-icon name="delete"></forge-icon>
    </forge-icon-button>
    }

    @for (action of primaryActions; track action) {
    <metadata-action [action]="action" [model]="model" enable-shortcut="false"
        (actionCallback)="afterActionCallback($event)">
    </metadata-action>
    }

@if (hasOverflowActions()) {
  <command-menu [commands]="commands" icon="more_vert" always-show-icon="true" fxLayout="row" fxLayoutAlign="space-between center" position="target-right bottom" telemetry="Menu-RowActions">
  </command-menu>
}
</div>